import { useDroppable } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import type { Board, BoardColumnDto, Task } from '../types'
import { ColumnMenu } from './ColumnMenu'
import { KanbanCard } from './KanbanCard'

interface KanbanColumnProps {
  column: BoardColumnDto
  board: Board
  onCardClick?: (task: Task) => void
}

/**
 * Kolumna na boardzie - droppable container z sortable lista kart.
 * id droppable = `column-<columnId>` (dla DnD); cards id = `card-<taskId>`.
 * Nagłówek pokazuje nazwę, licznik kart i menu (rename/delete/dodaj kolumnę).
 */
export function KanbanColumn({ column, board, onCardClick }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `column-${column.id}`,
    data: { type: 'column', columnId: column.id },
  })

  const cardIds = column.cards.map((c) => `card-${c.task.id}`)

  return (
    <div className="bg-slate-50 rounded-md w-72 flex-shrink-0 flex flex-col max-h-full">
      <div className="flex items-center justify-between px-2 py-2 border-b border-slate-200">
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-medium text-sm truncate">{column.name}</span>
          <span className="text-xs text-slate-500">{column.cards.length}</span>
        </div>
        <ColumnMenu board={board} column={column} />
      </div>
      <div
        ref={setNodeRef}
        className={`flex-1 p-2 overflow-y-auto ${isOver ? 'bg-sky-50' : ''}`}
      >
        <SortableContext items={cardIds} strategy={verticalListSortingStrategy}>
          {column.cards.map((c) => (
            <KanbanCard key={c.task.id} task={c.task} onClick={onCardClick} />
          ))}
        </SortableContext>
        {column.cards.length === 0 && (
          <div className="text-xs text-slate-400 text-center py-4">Brak kart</div>
        )}
      </div>
    </div>
  )
}
